import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

// 0–10 with standard labels (docs/01-PRODUCT-SPEC.md §3.2). The range is fixed on purpose: NPS
// stops being NPS — and stops being comparable across programmes — if the scale is configurable.
const configSchema = z.object({
  detractorLabel: z.string().max(60).default("Not at all likely"),
  promoterLabel: z.string().max(60).default("Extremely likely"),
});

export const npsField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "nps",
  label: "Net promoter score",
  category: "rating",
  icon: "Gauge",
  configSchema,
  valueSchema: (_config, isRequired) =>
    optionalUnlessRequired(z.number().int().min(0).max(10), isRequired),
  defaultConfig: { detractorLabel: "Not at all likely", promoterLabel: "Extremely likely" },
  supportsProfileBinding: false,
  defaultSearchable: false,
  sortKind: "numeric",
  renderHints: {},
};
